module.exports = __webpack_public_path__ + "img/icon_quick_kakao.f4390bd1.svg";